export default __webpack_public_path__ + "static/media/gl-16.03db46c9.png";